/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useMemo, useState, useContext, useEffect } from 'react';
import logo from 'Assets/logo_round.png';
import { AppContext, AuthContext } from 'Context';
import { axios, endpoints } from 'Api';
import styles from './index.module.css';

function PriceSectionLayout({
  planName,
  planPrice,
  intervalInDays,
  navigation,
  promoCode }) {
    const { affiliateCode, setAffiliatedCode } = useContext(AppContext);
    const [manager, setManager] = useState(null);
    const [active, setActive] = useState(false);
    const { getToken } = useContext(AuthContext);
    const handleAffiliatedCodeChange = async (event) => {
      const typedData = event.target.value;
      setAffiliatedCode(typedData);
      setManager('');
      if (event.target.value?.length > 4) {
        setActive(true);
        try {
          axios({
            url: endpoints.getAffiliateName,
            method: 'POST',
            data: { code: typedData, token: getToken() },
            headers: {
              'Content-Type': 'application/json',
            },
          }).then((response) => {
            setManager(`${response.data?.data?.firstname} ${response.data?.data?.lastname}`);
          });
        } catch (error) {
          console.error('Error:', error);
        }
      } else if (event.target.value < 5) {
        setActive(false);
      }
    };
    useEffect(() => {
    setAffiliatedCode(localStorage.getItem('code'));
    }, []);
  return (
    <>
      <div className={styles.mainDiv}>
        <p className={styles.title}>
          Projector Yearly Subscription
        </p>
        <p className={styles.subTitle}>{`$ ${planPrice?.amount ? planPrice?.amount : planPrice} / year` }</p>
        <div className={styles.logoDiv}>
          <div className={styles.logoDivImg}>
            <img width="50px" src={logo} />
          </div>
          <div className={styles.projectorTitleDiv}>
            <p className={styles.projectorTitle}>Projector</p>
            <p className={styles.projectorSubTitle}>Billed Annually</p>
            <p className={styles.subTotal}>Subtotal</p>
          </div>
          <div className={styles.projectorPriceDiv}>
            <p className={styles.price}>{`$ ${planPrice?.amount ? planPrice?.amount : planPrice}`}</p>
            <p style={{ marginTop: '23px' }} className={styles.price}>{`$ ${planPrice?.amount ? planPrice?.amount : planPrice}`}</p>
          </div>
        </div>
        {/* <div style={{ display: 'flex' }}>
        </div> */}
      {/* {navigation !== '/settings/manage-users' && ( */}
      {localStorage.getItem('code') ? (
  <p>{localStorage.getItem('code')}</p>
) : (
  <input
    className={styles.affiliatedCode}
    value={affiliateCode}
    onChange={handleAffiliatedCodeChange}
    disabled={promoCode}
    placeholder={promoCode || 'Add Affiliated code'}
  />
)}

            {/* <p className={styles.promoCode}>Add Promo Code</p> */}
        { manager
        ? (
        <p className={styles.mangerx}>
          Manger Name:
          {' '}
          {manager}
        </p>
        )
        : active === true
        ? (<p className={styles.invalid}>Invalid Code</p>)
      : null}
        <div className={styles.total}>
          <p>Total Due Today </p>
          <p className={styles.totalPrice}>{`$ ${planPrice?.amount ? planPrice?.amount : planPrice}`}</p>
        </div>
      </div>
    </>
  );
}

export default PriceSectionLayout;
